export default __webpack_public_path__ + "static/media/17ec093348709f4d9a72b3cbd7f80054.svg";